export default __webpack_public_path__ + "static/our-vision-904dd4d6847ae5b5f2d9a0e4e647b1e8.svg";